import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker' // TODO temp do not use web push notifications

// ----------------------------- o

import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';

import Ionic from '@ionic/vue';
Vue.use(Ionic);

// ----------------------------- o

import store from './store';
import router from './router';

// ----------------------------- o

import "@/assets/sass/app.scss";

// ----------------------------- o

import moment from 'moment';
Vue.prototype.$moment = moment;
moment.locale('pl');

// ----------------------------- o

Vue.config.ignoredElements = [/^ion-/];
Vue.config.productionTip = false;

// ----------------------------- o

import { ServerTable, ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable);
Vue.use(ServerTable);

// ----------------------------- o

const GAID = 'G-KY0T9BYW5Q'; //vox

import VueGtag from "vue-gtag";

function loadVueGtag() {
    console.log('__________________________________________loadVueGtag')

    Vue.use(VueGtag, {
        config: { id: GAID },
    }, router)

    router.afterEach((to, from) => {
        Vue.$gtag.pageview({
            page_path: to.fullPath
        });
    });
}

import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin'

Vue.use(VueCookieBot, {
    cookieBotID: '87d91dab-b5ce-4f55-a7b2-719f0a83500c'
})

// ----------------------------- o

function checkCookieConsent() {
    if (window.CookieConsent && window.CookieConsent.consent.statistics) {
        if (window.CookieConsent.consent.statistics) {
            loadVueGtag();
        }
    } else {
        setTimeout(checkCookieConsent, 3000);
    }
}

const app = new Vue({
    router,
    store,
    render: function (h) { return h(App) }
}).$mount('#app')

// Check Cookiebot consent after app is mounted
checkCookieConsent();

// Listen for consent changes
if (window.CookieConsent) {
    window.CookieConsent.onconsentchanged = function () {
        if (window.CookieConsent.consent && window.CookieConsent.consent.statistics) {
            loadVueGtag();
        }
    };
}

// access Vue instance by
// adding $app to store object
store.$app = app;
